// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import Axios from 'axios';
import { injectable } from 'inversify';

import { Id } from '@shared/types/common';
import OrderSummary, { OrderSummaryDTO } from '@shared/models/dashboard/order-summary';
import AssetSummary, { AssetSummaryDTO } from '@shared/models/dashboard/asset-summary';
import { assetSummaryTestDto1, assetSummaryTestDto2} from '@shared/constants/dashboard';
import { ListRequestParams } from '@shared/types/services';

@injectable()
export default class DashboardService {
  protected urlPrefix = 'dashboard';
  static diToken = Symbol('dashboard-service');
  static testOrders = false;
  static testJobRequests = false;

  async getOrderSummary(params: ListRequestParams): Promise<OrderSummary> {
    try {
      if (DashboardService.testOrders == false)
      {
        const dateRange = params.filtering?.dateRange !== undefined ? params.filtering?.dateRange : []; 
        const url = this.getURL('orders');
        const { data } = await Axios.get<Partial<OrderSummaryDTO>>(url, {
          params: { dateRange: dateRange}
        });

        return new OrderSummary(data[0]);
      }
      
      {
        const data: OrderSummaryDTO = {
          standing: 'all',
          normalCount: 2,
          warningCount: 0,
          criticalCount: 0,
          overdueCount: 0,
        };

        return new OrderSummary(data);
      }
    } catch (err) {
      throw err;
    }
  }

  async getAssetSummary(params: ListRequestParams): Promise<AssetSummary> {
    try {
      if (DashboardService.testJobRequests == false)
      {
        const dateRange = params.filtering?.dateRange !== undefined ? params.filtering?.dateRange : []; 
        const url = this.getURL('assets');
        const { data } = await Axios.get<Partial<AssetSummaryDTO>>(url, {
          params: { dateRange: dateRange}
        });
        const assetData: AssetSummaryDTO = {
          pending: data[1],
          scheduled: data[2],
          collected: data[3],
          processed: data[4],
          delivered: data[5]
        };
        
        return new AssetSummary(assetData);
      } 
      
      {
        const assetData: AssetSummaryDTO = {
          pending: assetSummaryTestDto1,
          scheduled: assetSummaryTestDto2,
          collected: assetSummaryTestDto1,
          processed: assetSummaryTestDto1,
          delivered: assetSummaryTestDto1
        };

        return new AssetSummary(assetData);
      }

    } catch (err) {
      throw err;
    }
  }

  getURL(path: Id) {
    
    return `${this.urlPrefix}/${path}`;
  }
}
